import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15edce23&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=15edce23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15edce23",
  null
  
)

export default component.exports